import React, { useState, useEffect, useMemo } from 'react';
import { Link } from "react-router-dom";
import 'bootstrap/dist/css/bootstrap.min.css';
import { usePlantData } from '../../../components/data/PlantData';
import { usePortfolioData } from '../../../components/data/PortfolioData';
import SidebarPageLayout from '../../../components/layout/SidebarPageLayout';
import Marquee from '../../../components/layout/Marquee';
import Breadcrumbs from '../../../components/layout/Breadcrumbs';
import MetricChartPanel from '../../../components/layout/panels/MetricChartPanel';
import MonthlyActualsVsPredicted from '../../../components/graphs/MonthlyActualsVsPredicted';
import CumulativeActualsVsPredicted from '../../../components/graphs/CumulativeActualsVsPredicted';
import ChartTooltip from '../../../components/layout/ChartTooltip';
import { toSlug } from '../../../util/strings';
import { usePortfolioDateFormatter } from '../../../utils/usePortfolioDateFormatter';

function normalizePortfolioKey(value = '') {
  return String(value).toLowerCase().replace(/[^a-z0-9]/g, '');
}

function DataQuality() {
  const { plant: gemini } = usePlantData();
  const { data: portfolios } = usePortfolioData();
  const portfolioName = toSlug(gemini.plant_name) ?? "";
  const dateFormatter = usePortfolioDateFormatter({ portfolioName });
  const lastUpdated = useMemo(() => {
    const normalized = normalizePortfolioKey(portfolioName);
    const match = (portfolios ?? []).find((node) => (
      normalizePortfolioKey(node.portfolio_name) === normalized
      || normalizePortfolioKey(node.plant_name) === normalized
    ));
    return match?.last_updated ?? null;
  }, [portfolios, portfolioName]);
  const [tooltip, setTooltip] = useState({ visible: false, x: 0, y: 0, content: '' });

  useEffect(() => {
    document.title = "Vivosol Plant Performance Insights Hub | Gemini / Insights / PV System Comparison";
  }, []);

  return (
    <SidebarPageLayout>
      <div className="content p-5">
        <ChartTooltip tooltip={tooltip} transition={false} />
        <Marquee />
        <div className="d-flex justify-content-between align-items-start gap-3 mt-3">
          <h1 className="mb-0"><Link to={`${gemini.dashboard}`}><strong>{gemini.plant_name}</strong></Link> : {gemini.config} ({gemini.location})</h1>
          {lastUpdated ? (
            <span className="text-nowrap small pt-1" title="KPI last updated">
              <strong>Last Updated:</strong> {dateFormatter.formatUtc(lastUpdated)}
            </span>
          ) : null}
        </div>
        <Breadcrumbs labels={{ portfolioName: gemini.plant_name }} />
        
        <MetricChartPanel
          id="monthlyActualsVsPredicted"
          title="MONTHLY ACTUALS vs PREDICTED"
          dataEndpoint={`/api/graph/portfolio/${portfolioName}/duel-metrics/last-2-years/production/production-predicted`}
          dataMetrics={true}
          onTooltip={setTooltip}
          chart={<MonthlyActualsVsPredicted portfolioName={portfolioName} />}
        />

        <MetricChartPanel
          id="cumulativeActualsVsPredicted"
          title="CUMULATIVE ACTUALS vs PREDICTED"
          dataEndpoint={`/api/graph/portfolio/${portfolioName}/duel-metrics/last-2-years/production/production-predicted?cumulative=1`}
          dataMetrics={true}
          onTooltip={setTooltip}
          chart={<CumulativeActualsVsPredicted portfolioName={portfolioName} />}
        />

      </div>
    </SidebarPageLayout>
  );
}

export default DataQuality;
